import {call, put, takeEvery} from 'redux-saga/effects'
import Api from '../services/Api'

function* fetchMainServices() {
  try {
    const mainServices = yield call(function() {
      return Api.get('/dealer/main-services');
    });
    yield put({type: 'FETCH_MAIN_SERVICES.SUCCESS', mainServices})
  } catch (error) {
    yield put({type: 'FETCH_MAIN_SERVICES.FAILURE', error})
  }
}

export function* watchFetchMainServices() {
  yield takeEvery('FETCH_MAIN_SERVICES.REQUEST', fetchMainServices);
}

function* saveMainServices(action) {
  try {
    yield call(function () {
      return Api.post('/dealer/main-services', action.body);
    });
    yield put({type: 'SHOW_NOTIFICATION', notification:{message:'save.success'}});
    yield put({type: 'FETCH.DEALER_CONFIGURATION_CHECK.REQUEST'});
    yield put({type: 'SAVE_MAIN_SERVICES.SUCCESS'});
  } catch (error) {
    yield put({type: 'SAVE_MAIN_SERVICES.FAILURE', error})
  }
}

export function* watchSaveMainServices() {
  yield takeEvery('SAVE_MAIN_SERVICES.REQUEST', saveMainServices)
}
